<template>
	<div>
		<slot name="heading"></slot>
		<nav class="c-feed__nav">
			<button
				@click="prev"
				class="c-feed__button"
				:class="{'is-active': hasPrev, 'is-inactive': !hasPrev}"
				aria-label="Previous"
			>
				<span class="icon"><arrowLeft/></span>
			</button>
			<button
				@click="next"
				class="c-feed__button"
				:class="{'is-active': hasNext, 'is-inactive': !hasNext}"
				aria-label="Next"
			>
				<span class="icon"><arrowRight/></span>
			</button>
		</nav>

		<vue-horizontal
			:button="false"
			ref="horizontal"
			@scroll-debounce="onScroll"
			class="c-feed__list"
		>
			<slot name="slides"></slot>
		</vue-horizontal>
	</div>
</template>

<script>
	import VueHorizontal from "vue-horizontal";
	import arrowLeft from '/web/static/images/svgs/icon-arrow-left.svg?component';
	import arrowRight from '/web/static/images/svgs/icon-arrow-right.svg?component';

	export default {
		name: "feed-row",
		components: {
			VueHorizontal,
			arrowLeft,
			arrowRight
		},
		data() {
			return {
				hasPrev: false,
				hasNext: true,
			}
		},
		methods: {
			prev(e) {
				this.$refs.horizontal.prev(e)
			},
			next(e) {
				this.$refs.horizontal.next(e)
			},
			onScroll({hasPrev, hasNext}) {
				this.hasPrev = hasPrev
				this.hasNext = hasNext
			}
		}
	};
</script>
